import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'sc-field-radio-card',
  templateUrl: './field-radio-card.component.html',
  styleUrls: ['./field-radio-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldRadioCardComponent extends FieldType implements OnInit {
  defaultOptions = {
    templateOptions: {
      formCheck: 'custom' // 'custom' | 'custom-inline' | 'stacked' | 'inline'
    }
  };
  ngOnInit(): void {}
}
